<template>
  <section class="flex items-center justify-center">
    <div class="notfound-content">
      <h2 class="text-6xl mb-3">HTTPS 404</h2>
      <h6 class="text-xl">Something Wrong !!</h6>
      <h4 class="text-3xl">BUG : PAGE NOT FOUND |`)</h4>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style scoped>
.notfound-content > * {
  @apply text-center;
  font-family: '8bit', sans-serif;
}
</style>
